import { useCallback, useEffect, useState } from "react";
import ConnorsApplyConfirmDialog from "./ConnorsApplyConfirmDialog";
import { registerConnorsApplyConfirmRequest } from "./connorsApplyConfirmRegistry";
import { shouldSkipConnorsApplyPopup } from "./connorsStorage";

export function useConnorsApplyConfirm() {
  const [open, setOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const requestApplyConfirm = useCallback((onConfirm) => {
    if (typeof onConfirm !== "function") {
      return;
    }

    if (shouldSkipConnorsApplyPopup()) {
      onConfirm();
      return;
    }

    setPendingAction(() => onConfirm);
    setOpen(true);
  }, []);

  useEffect(() => {
    registerConnorsApplyConfirmRequest(requestApplyConfirm);
    return () => registerConnorsApplyConfirmRequest(null);
  }, [requestApplyConfirm]);

  const handleClose = useCallback(() => {
    setOpen(false);
    setPendingAction(null);
  }, []);

  const handleConfirm = useCallback(() => {
    pendingAction?.();
    setPendingAction(null);
  }, [pendingAction]);

  const ApplyConfirmDialog = (
    <ConnorsApplyConfirmDialog
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
    />
  );

  return { requestApplyConfirm, ApplyConfirmDialog };
}
